import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { sendStartOverMessage } from '@utils/station';
import type { SpacesUseCaseType } from '@utils/station';

const USE_CASE_IMAGE_MAP: Record<SpacesUseCaseType, string> = {
  hospitality: 'https://demoassets.touchcast.com/station-assets/ise/usecases/hospitality.jpg',
  retail: 'https://demoassets.touchcast.com/station-assets/ise/usecases/retail.jpg',
  transit: 'https://demoassets.touchcast.com/station-assets/ise/usecases/transit.jpg',
};

interface StationSpacesUseCaseViewProps {
  useCaseType: SpacesUseCaseType;
}

export const StationSpacesUseCaseView = ({
  useCaseType,
}: StationSpacesUseCaseViewProps) => {
  const navigate = useNavigate();
  const imageSrc = USE_CASE_IMAGE_MAP[useCaseType] ?? USE_CASE_IMAGE_MAP.hospitality;
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.onload = () => setImageLoaded(true);
    img.onerror = () => setImageLoaded(true);
    img.src = imageSrc;
  }, [imageSrc]);

  const handleStartOver = useCallback(() => {
    sendStartOverMessage();
    navigate('/');
  }, [navigate]);

  return (
    <div className="fixed inset-0 flex flex-col text-white overflow-hidden bg-black">
      {imageLoaded && (
        <div
          className="absolute inset-0 bg-contain bg-center bg-no-repeat transition-opacity duration-300 opacity-100"
          style={{
            backgroundImage: `url(${imageSrc})`,
          }}
        />
      )}
      <div className="absolute inset-0 z-20 flex flex-col h-full w-full p-10 sm:p-12 md:p-14">
        <div className="absolute top-11 right-8 sm:right-12 md:right-16 z-20 flex justify-end items-center">
          <button
            onClick={handleStartOver}
            className="px-6 py-4 bg-black rounded-full text-white text-xl font-medium font-['DM_Sans'] leading-6 hover:bg-gray-900 transition-colors border border-white/20">
            Start Over
          </button>
        </div>
      </div>
    </div>
  );
};
